<!-- 车辆成本申请 -->
<template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug
      :btndata="BTN_CONFIG"
      @btnEvent="callBack"
      @clearBtns="clearBtns"
      @moreParam="moreParam"
      @queryBtn_ok="queryBtn_ok"
      ref="btnList"
    />
    <!-- 查询列表 -->
    <input-plug
      ref="queryForm"
      :form-config="baseConfig"
      :form-data="queryData"
      :More="isHaseMore"
      @changeCallback="rowCallback"
    >
      <template slot="time1">
        <multitime
          :timeType="timeType"
          :timeTypes="timeTypes"
          :startTime="startTime_a"
          :endTime="endTime_a"
          @timestatus="timestatus"
          @queryBtn_ok="queryBtn_time"
        />
      </template>
    </input-plug>

    <!-- 表格 -->
    <table-plug
      :tableConfig="tableConfig"
      :defaulthead="myTableHeard"
      :totals="totalArr"
      ref="mytable"
      @rowCallback="rowCallback"
      @selectChange="handleSelectionChange"
      @jumpPage="goYdDetails"
    />
    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    />
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />

    <!-- 车辆档案新增弹窗 -->
    <my-dialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn"
    >
      <dia-form
        :diaFormConfig="diaFormConfig"
        :baseModel="baseModel"
        ref="diaform"
        :rules="formRules"
        :Reset="isShowDialog"
        @changeCallback="rowCallback"
      />
    </my-dialog>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug
        ref="queryForm"
        :form-config="baseConfig"
        :form-data="queryData"
        :More="true"
        @changeCallback="rowCallback"
      >
        <template slot="time1">
          <multitime
            :timeType="timeType"
            :timeTypes="timeTypes"
            :startTime="startTime_a"
            :endTime="endTime_a"
            @timestatus="timestatus"
            @queryBtn_ok="queryBtn_time"
          />
        </template>
      </input-plug>
    </exportCompoent>
  </div>
</template>
<script>
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import { mixin_print } from "@/assets/js/Mixins/mixinPrint";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import MyDialog from "@/components/Dialog.vue";
import DiaForm from "@/pages/VMS/VMSConpon/DiaForm.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js

export default {
  mixins: [mixin_1, mixin_print, exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
    DiaForm,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "车辆成本", //导出时默认文件名
        apiName: "/admin/v3/finance/other/getOtherOutList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "新增",
          method: "addClick",
          permissVal: "admin:other_finance:addCarCost",
        },

        {
          name: "表格设置",
          method: "SetTable",
          permissVal: "aaaaa",
        },
        {
          name: "导出",
          method: "ExportData",
          permissVal: "aaaaa",
        },
        // {
        //   name: "打印",
        //   method: "printEvent",
        //   permissVal: "aaaaa",
        // },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "timeSelect",
          slotName: "time1",
        },
        {
          type: "input",
          label: "车牌号码",
          field: "carNumber",
          placeholder: "请输入",
        },
        {
          type: "input",
          label: "经办人",
          field: "handelObjectName",
          placeholder: "请输入",
        },
        {
          type: "selectloadmore",
          label: "业务部门",
          field: "businessDeptId",
          placeholder: "输入部门进行匹配",
          loadmoreMethod: "loaddept",
          remotemethod: "remotedept",
          loading: false,
          setLabel: "departmentName",
          setValue: "deptId",
          selectOptions: [],
        },
        {
          type: "select",
          label: "需要核销",
          field: "isSettlement",
          placeholder: "请选择",
          selectOptions: [
            { label: "是", val: "1" },
            { label: "否", val: "0" },
          ],
        },
        {
          type: "doubleSelect",
          label: "费项",
          selectItem: [
            {
              field: "itemCategoryId",
              placeholder: "请选择",
              setLabel: "categoryName",
              setValue: "categoryId",
              selectChange: "GetExpenditure",
              selectOptions: [],
            },
            {
              field: "itemServiceId",
              placeholder: "请选择",
              setLabel: "title",
              setValue: "itemServiceId",
              selectOptions: [],
            },
          ],
        },
        {
          type: "doubleSelect",
          label: "结算对象",
          selectItem: [
            {
              field: "objectStatusConfDictId",
              placeholder: "请输入",
              setLabel: "val",
              setValue: "confDictId",
              selectChange: "GetUserDownList",
              selectOptions: [],
            },
            {
              field: "objectName",
              placeholder: "请输入",
              setLabel: "name",
              setValue: "name",
              selectOptions: [],
            },
          ],
        },
      ],

      queryData: {
        businessDeptId: null,
        carNumber: null,
        documentStatus: null,
        endCreateTime: null,
        endOccurrenceTime: null,
        handelObjectName: null,
        isPosting: null,
        isSettlement: null,
        itemCategoryId: null,
        itemServiceId: null,
        objectName: null,
        objectStatusConfDictId: null,
        settlementMethodConfDictId: null,
        startCreateTime: null,
        startOccurrenceTime: null,
      },
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "发生日期",
        },
        {
          value: "1",
          label: "创建时间",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",
      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "操作",
          field: "edit",
          width: 220,
          Buttons: [
            {
              method: "modifyClick",
              methodName: "修改",
              permissVal: "admin:other_finance:updateCarCost",
            },
            {
              method: "delete",
              methodName: "删除",
              permissVal: "admin:other_finance:delCarCost",
            },
            {
              method: "posting",
              methodName: "过账",
              permissVal: "admin:other_finance:postingCarCost",
            },
            {
              method: "Reposting",
              methodName: "反过账",
              permissVal: "admin:other_finance:postingCarCost",
            },
          ],
        },
        {
          name: "车辆成本单号",
          field: "number",
          width: "140",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车牌号码",
          field: "carNumber",
          width: "120",
          sort: 4,
          isShow: true,
          isSort: true,
        },
        {
          name: "车辆费用类型",
          field: "documentStatusShow",
          width: "140",
          sort: 5,
          isShow: true,
        },
        {
          name: "发生时间",
          field: "occurrenceTime",
          width: "120",
          sort: 5,
          isShow: true,
        },
        {
          name: "业务部门",
          field: "businessDeptName",
          width: "160",
          sort: 6,
          isShow: true,
        },
        {
          name: "发生金额",
          field: "amount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "数量",
          field: "totalCount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "是否需要核销",
          field: "isSettlementShow",
          width: "140",
          sort: 18,
          isShow: true,
        },
        {
          name: "结算对象类型",
          field: "objectStatus",
          width: "140",
          sort: 19,
          isShow: true,
        },
        {
          name: "结算对象",
          field: "objectName",
          width: "120",
          sort: 19,
          isShow: true,
        },
        {
          name: "付款方式",
          field: "settlementMethod",
          width: "120",
          sort: 19,
          isShow: true,
        },
        {
          name: "经办人",
          field: "handelObjectName",
          width: "120",
          sort: 19,
          isShow: true,
        },
        {
          name: "备注",
          field: "remark",
          width: "120",
          sort: 19,
          isShow: true,
        },
        {
          name: "过账状态",
          field: "isPostingShow",
          width: "120",
          sort: 19,
          isShow: true,
        },
        {
          name: "过账时间",
          field: "postingTime",
          width: "120",
          sort: 19,
          isShow: true,
        },
        {
          name: "过账人",
          field: "postingUserName",
          width: "120",
          sort: 1,
          isShow: true,
        },
      ],
      pageGroupName: "VOCApply",
      sortName: "车辆成本申请", //  排序名
      //   车辆弹窗
      diaWidth: "60%",
      dialogTitle: "车辆成本申请",
      isShowDialog: false,
      diaFormConfig: [
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "车牌号码",
              itemType: "select",
              field: "carNumber",
              placeholder: "请选择",
              setLabel: "carNumber",
              setValue: "carNumber",
              options: [],
            },
            {
              span: 8,
              title: "费项类型",
              itemType: "select",
              field: "itemCategoryId",
              placeholder: "请选择",
              setLabel: "categoryName",
              setValue: "categoryId",
              selectChange: "GetExpenditure",
              options: [],
            },
            {
              span: 8,
              title: "费项",
              itemType: "select",
              field: "itemServiceId",
              placeholder: "请选择",
              setLabel: "title",
              setValue: "itemServiceId",
              options: [],
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "业务网点",
              itemType: "selectloadmore",
              field: "businessDeptId",
              placeholder: "输入网点进行匹配",
              loadmoreMethod: "loadDiadept",
              remotemethod: "remoteDiadept",
              loading: false,
              setLabel: "departmentName",
              setValue: "deptId",
              options: [],
            },
            {
              span: 8,
              title: "发生日期",
              itemType: "datetime",
              field: "occurrenceTime",
              placeholder: "请选择",
            },
            {
              span: 8,
              title: "发生金额",
              itemType: "input",
              field: "amount",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "结算对象类型",
              itemType: "select",
              field: "objectStatusConfDictId",
              placeholder: "请选择",
              labelwidth: "120",
              setLabel: "val",
              setValue: "confDictId",
              selectChange: "GetUserDownList",
              options: [],
            },
            {
              span: 8,
              title: "结算对象",
              itemType: "select",
              field: "objectNumber",
              placeholder: "请选择",
              setLabel: "name",
              setValue: "number",
              options: [],
            },
            {
              span: 8,
              title: "付款方式",
              itemType: "select",
              field: "settlementMethodConfDictId",
              placeholder: "请选择",
              setLabel: "val",
              setValue: "confDictId",
              options: [],
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "数量",
              itemType: "input",
              field: "totalCount",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "需要核销",
              itemType: "select",
              field: "isSettlement",
              placeholder: "请选择",
              options: [
                {
                  label: "是",
                  val: 1,
                },
                {
                  label: "否",
                  val: 0,
                },
              ],
            },
            {
              span: 8,
              title: "经办人",
              itemType: "select",
              field: "handelObjectId",
              placeholder: "请选择",
              setLabel: "name",
              setValue: "documentId",
              options: [],
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "经办日期",
              itemType: "datetime",
              field: "handelTime",
              placeholder: "请选择",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "备注",
              itemType: "textarea",
              field: "remark",
              placeholder: "请输入",
            },
          ],
        },
      ],
      formRules: {
        businessDeptId: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        carNumber: [{ required: true, message: "请选择", trigger: "change" }],
        isSettlement: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        itemCategoryId: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        itemServiceId: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        objectNumber: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        objectStatusConfDictId: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        occurrenceTime: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        settlementMethodConfDictId: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        amount: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      baseModel: {
        itemCategoryId: null,
        itemCategoryName: null,
        itemServiceId: null,
        itemServiceName: null,
        objectNumber: null,
        objectName: null,
      },
      defaultBaseModel: {
        amount: null,
        businessDeptId: null,
        carNumber: null,
        handelObjectId: null,
        handelTime: null,
        isSettlement: null,
        itemCategoryId: null,
        itemCategoryName: null,
        itemServiceId: null,
        itemServiceName: null,
        objectNumber: null,
        objectName: null,
        objectStatusConfDictId: null,
        occurrenceTime: null,
        remark: null,
        settlementMethodConfDictId: null,
        totalCount: null,
      },
      DeptPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
      },
      DiaDeptPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
      },
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;
    this.GetData();
    this.GetConfDictValDownList("object_status");
    this.GetConfDictValDownList("settlement_method");
    this.GetCarDownList();
    this.GetItemCategorChoose();
    this.GetDept();
    this.GetUserDownList("ALL");
  },
  methods: {
    // 获取车辆成本申请(共用其他支出列表)
    GetData() {
      let startTime = this.startTime_a ? this.startTime_a + " 00:00:00" : "";
      let endTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";
      if (this.timeType == "0") {
        this.queryData.startOccurrenceTime = startTime;
        this.queryData.endOccurrenceTime = endTime;
        this.queryData.startCreateTime = "";
        this.queryData.endCreateTime = "";
      }
      if (this.timeType == "1") {
        this.queryData.startCreateTime = startTime;
        this.queryData.endCreateTime = endTime;
        this.queryData.startOccurrenceTime = "";
        this.queryData.endOccurrenceTime = "";
      }
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.$API.OtherOutList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableConfig.tableData = res.data.result?.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---车辆成本申请列表`);
        }
      });
    },

    // 字典获取结算对象类型 & 付款方式
    GetConfDictValDownList(param) {
      this.$API.getConfDictValDownList({ dictType: param }).then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result || [];
          // 结算对象类型
          if (param === "object_status") {
            this.baseConfig[6].selectItem[0].selectOptions = result;
            this.diaFormConfig[2].formItem[0].options = result;
          }
          if (param === "settlement_method") {
            this.diaFormConfig[2].formItem[2].options = result;
          }
        }
      });
    },

    // 获取车辆下拉列表
    GetCarDownList() {
      this.$API.CarDownList().then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result?.data || [];
          this.diaFormConfig[0].formItem[0].options = result;
        }
      });
    },

    // 获取费项类型下拉列表
    GetItemCategorChoose() {
      this.$API.itemCategorChoose().then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result || [];
          this.baseConfig[5].selectItem[0].selectOptions = result;
          this.diaFormConfig[0].formItem[1].options = result;
        }
      });
    },

    // 根据类别和费项类型获取费项
    GetExpenditure(e) {
      this.$API.CategoryServiceList({ categoryId: e }).then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result || [];
          // 区分表格筛选跟表单的数据
          if (this.isShowDialog) {
            this.diaFormConfig[0].formItem[2].options = result;
          } else {
            this.itemServiceId = "";
            this.baseConfig[5].selectItem[1].selectOptions = result;
          }
        }
      });
    },

    // 获取业务网点（组织架构列表）
    GetDept(e, checkedData) {
      let query = {
        pageStart: this.DeptPage.pageStart,
        pageTotal: this.DeptPage.pageTotal,
        deptName: e,
        deptId: checkedData,
      };
      if (this.isShowDialog) {
        query.pageStart = this.DiaDeptPage.pageStart;
        query.pageTotal = this.DiaDeptPage.pageTotal;
      }
      this.$API
        .wtl_getDeptList(query)
        .then((res) => {
          if (res.data.status === "success") {
            let result = res.data.result?.data || [];
            let arr = [];
            let ComfirmRes = [];
            // 区分弹窗和列表
            if (this.isShowDialog) {
              arr = this.diaFormConfig[1].formItem[0].options;
            } else {
              arr = this.baseConfig[3].selectOptions;
            }

            if (e) {
              ComfirmRes = result;
            } else {
              ComfirmRes = [
                ...arr,
                ...result.filter(
                  (item) => !arr.some((x) => x.deptId === item.deptId)
                ),
              ];
            }
            if (this.isShowDialog) {
              this.diaFormConfig[1].formItem[0].loading = false;
              this.diaFormConfig[1].formItem[0].options = ComfirmRes;
            } else {
              this.baseConfig[3].loading = false;
              this.baseConfig[3].selectOptions = ComfirmRes;
            }
            if (!e && !checkedData) {
              if (this.isShowDialog) {
                this.DiaDeptPage.pageCount = res.data.result?.pageCount || 0;
              } else {
                this.DeptPage.pageCount = res.data.result?.pageCount || 0;
              }
            }
          }
        })
        .catch((catchres) => {
          if (this.isShowDialog) {
            this.diaFormConfig[1].formItem[0].loading = false;
          } else {
            this.baseConfig[3].loading = false;
          }
        });
    },
    //   列表业务部门select 滚动加载更多数据
    loaddept() {
      let count = this.DeptPage.pageCount / this.DeptPage.pageTotal;
      if (count > this.DeptPage.pageStart) {
        this.baseConfig[3].loading = true;
        this.DeptPage.pageStart += 1;
        this.GetDept();
      } else {
        console.log("数据已全部加载");
      }
    },
    // 弹窗业务网点滚动加载更多数据
    loadDiadept() {
      let count = this.DiaDeptPage.pageCount / this.DiaDeptPage.pageTotal;
      if (count > this.DiaDeptPage.pageStart) {
        this.diaFormConfig[1].formItem[0].loading = true;
        this.DiaDeptPage.pageStart += 1;
        this.GetDept();
      } else {
        console.log("数据已全部加载");
      }
    },
    // 列表业务部门远程搜索
    remotedept(e) {
      this.DeptPage.pageStart = 1;
      if (e !== "") {
        this.baseConfig[3].loading = true;
        this.GetDept(e);
      } else {
        this.GetDept();
      }
    },
    // 弹窗业务网店远程搜索
    remoteDiadept(e) {
      this.DiaDeptPage.pageStart = 1;
      if (e !== "") {
        this.diaFormConfig[1].formItem[0].loading = true;
        this.GetDept(e);
      } else {
        this.GetDept();
      }
    },
    // 根据结算对象类型获取结算对象 & 获取经办人数据
    GetUserDownList(e) {
      let arr = this.diaFormConfig[2].formItem[0].options;
      let num = arr.findIndex((element) => element.confDictId == e);
      let objectKey = null;
      if (e == "ALL") {
        objectKey = "employee";
      } else {
        if (num == -1) return false;
        objectKey = arr[num].key;
      }
      this.$API
        .wtl_getObjectUserDownList({
          key: objectKey,
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          if (res.data.status === "success") {
            let result = res.data.result?.data || [];
            // 获取经办人数据
            if (e == "ALL") {
              this.diaFormConfig[3].formItem[2].options = result;
            }
            // 获取弹窗表单需要的数据
            if (this.isShowDialog && e !== "ALL") {
              this.baseModel.objectNumber = null;
              this.diaFormConfig[2].formItem[1].options = result;
            }
            // 获取筛选表单需要的数据
            if (!this.isShowDialog && e !== "ALL") {
              this.queryData.objectName = "";
              this.baseConfig[6].selectItem[1].selectOptions = result;
            }
          }
        });
    },

    // 结算对象选中的时候获取结算对象名称
    // GetObjectNumber(e) {
    //   let Data = this.diaFormConfig[2].formItem[1].options;
    //   let i = Data.findIndex((element) => element.number == e);
    //   this.baseModel.objectName = Data[i].name;
    // },
    // 表格内按钮的&表单里面的回调事件
    rowCallback(data, name) {
      this[name](data);
    },

    // 新增
    addClick() {
      this.isShowDialog = true;
      this.GetDept();
    },
    // 修改
    async modifyClick(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        this.isShowDialog = true;
        await this.GetDept();
        this.baseModel = this.selectTableData[0];
        this.GetDept("", this.selectTableData[0].businessDeptId);
      }
    },
    // 删除
    delete(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要删除所选数据吗?", "提示:")
          .then((res) => {
            let delReq = {
              otherIds: new Array(),
            };
            this.selectTableData.map(function(val, i) {
              delReq.otherIds.push(val.otherId);
            });
            this.$API.delCarCost(delReq).then((res) => {
              if (res.data.status === "success") {
                try {
                  let num = 0;
                  let arr = this.tableConfig.tableData;
                  if (delReq.otherIds.length > 2) {
                    delReq.otherIds.map(function(v, i) {
                      num = arr.findIndex((element) => element.otherId == v);
                      arr.splice(num, 1);
                    });
                  } else {
                    num = arr.findIndex(
                      (element) => element.otherId == delReq.otherIds[0]
                    );
                    arr.splice(num, 1);
                  }
                } catch {
                  this.GetData();
                }
                this.$message.success("已删除");
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 过账
    posting(data, t) {
      if (data) this.selectTableData = [data];
      let msg = "过账";
      if (t) msg = t;
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm(`确认要把所选数据操作${msg}?`, "提示:")
          .then((res) => {
            let params = {
              otherIds: new Array(),
            };
            this.selectTableData.map(function(val, i) {
              params.otherIds.push(val.otherId);
            });

            if (t) {
              // 反过账
              this.$API.unPostingOtherOut(params).then((r) => {
                if (r.data.status === "success") {
                  this.GetData();
                  this.$message.success(res.data.message);
                }
              });
            } else {
              // 过账（无接口）
              this.$API.postingCarCost(params).then((e) => {
                if (e.data.status === "success") {
                  this.GetData();
                  this.$message.success(res.data.message);
                }
              });
            }
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 返过账
    Reposting(data) {
      this.posting(data, "反过账");
    },

    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.startTime_a = "";
      this.endTime_a = "";
      this.queryData.objectName = "";
      this.queryData.objectStatusConfDictId = "";
      this.queryData.itemCategoryId = "";
      this.queryData.itemServiceId = "";
      this.GetData();
    },
    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    // // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 跳转运单详情
    goYdDetails(a) {
      this.$message.success("你点我干嘛");
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.$refs["diaform"].$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交
          let param = {};
          for (let key in this.defaultBaseModel) {
            if (this.baseModel[key] || this.baseModel[key] == 0) {
              eval("param." + key + "='" + this.baseModel[key] + "'");
            } else {
              eval("param." + key + "=''");
            }
          }
          // 获取费项类型名称
          let itemCategoryNameArr = this.diaFormConfig[0].formItem[1].options;
          let index_1 = itemCategoryNameArr.findIndex(
            (elem) => elem.categoryId == this.baseModel.itemCategoryId
          );
          param.itemCategoryName = itemCategoryNameArr[index_1].categoryName;

          // 获取费项名称
          let itemServiceNameArr = this.diaFormConfig[0].formItem[2].options;
          let index_2 = itemServiceNameArr.findIndex(
            (elem) => elem.itemServiceId == this.baseModel.itemServiceId
          );
          param.itemServiceName = itemServiceNameArr[index_2].title;

          // 获取对象名称
          let objectNameArr = this.diaFormConfig[2].formItem[1].options;
          let index_3 = objectNameArr.findIndex(
            (elem) => elem.number == this.baseModel.objectNumber
          );
          param.objectName = objectNameArr[index_3].name;

          if (this.baseModel.otherId) param.otherId = this.baseModel.otherId;
          if (param.otherId) {
            // 修改接口
            this.$API.updateCarCost(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          } else {
            // 新增接口
            this.$API.addCarCost(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.handleCloseDia();
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.baseModel = {};
      this.selectTableData.length = 0;
      this.$refs.mytable.$refs.tables.clearSelection();
      this.isShowDialog = false;
    },
    // 表格设置
    SetTable() {
      this.$TOOLS.myModel(this);
    },
    // 导出
    ExportData() {
      // this.$COMAPI.exportBtn({
      //   pageGroupName: this.pageGroupName, //页面标识
      //   myTableHeard: this.myTableHeard, //表头数组
      //   className: this.className, //列表标识
      //   tableData: this.tableConfig.tableData, //数据源
      //   sheetName: "表名(暂无效)", //表名
      // });
      this.isShowDialog_dc = true;
    },
  },
};
</script>
<style scoped lang="less"></style>
